import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { FlexBoxProps, FlexCol, FlexGrowRow, FlexRow } from '@xylabs/sdk-react'
import React from 'react'
import { FaAngleDown } from 'react-icons/fa'

import {
  AuctionCostProperty,
  AuctionMintedProperty,
  AuctionMintingRewardProperty,
  GeotokenBalanceProperty,
  GeotokenBurnedProperty,
  GeotokenFlowedInProperty,
  GeotokenFlowedOutProperty,
  GeotokenLockedProperty,
  GeotokenOwnerProperty,
  GeotokenProfitProperty,
} from '../../../Properties'

const InfoAccordian: React.FC<FlexBoxProps> = (props) => {
  return (
    <FlexRow paper justifyContent="stretch" {...props}>
      <Accordion defaultExpanded style={{ flexGrow: 1 }}>
        <AccordionSummary>
          <FlexGrowRow justifyContent="space-between">
            <Typography variant="caption">Information</Typography>
            <FaAngleDown />
          </FlexGrowRow>
        </AccordionSummary>
        <AccordionDetails>
          <FlexCol alignItems="stretch">
            <GeotokenOwnerProperty />
            <AuctionMintedProperty />
            <GeotokenLockedProperty />
            <AuctionCostProperty />
            <GeotokenFlowedInProperty />
            <GeotokenFlowedOutProperty />
            <GeotokenBurnedProperty />
            <AuctionMintingRewardProperty />
            <GeotokenProfitProperty />
            <GeotokenBalanceProperty />
          </FlexCol>
        </AccordionDetails>
      </Accordion>
    </FlexRow>
  )
}

export default InfoAccordian
